import { ACTIVE_CHALLENGE_STORAGE_KEY } from '../../config/storage.config'

const ACTIVE_CHALLENGE_EVENT = 'activeChallengeChanged'

export function getStoredActiveChallengeId(): string {
  if (typeof localStorage === 'undefined') return ''
  return localStorage.getItem(ACTIVE_CHALLENGE_STORAGE_KEY) ?? ''
}

export function setActiveChallengeId(challengeId: string): void {
  localStorage.setItem(ACTIVE_CHALLENGE_STORAGE_KEY, challengeId)
  window.dispatchEvent(new Event(ACTIVE_CHALLENGE_EVENT))
}

export function subscribeActiveChallengeId(onChange: () => void): () => void {
  window.addEventListener(ACTIVE_CHALLENGE_EVENT, onChange)
  window.addEventListener('storage', onChange)
  return () => {
    window.removeEventListener(ACTIVE_CHALLENGE_EVENT, onChange)
    window.removeEventListener('storage', onChange)
  }
}
